module.exports = __webpack_public_path__ + "static/carbon-button-small-36711697fa86b4d9d7309a728ecb82b8.png";